// extracted by mini-css-extract-plugin
export default {"layout":"Main__layout--HmjgH","body":"Main__body--oS6sy","header":"Main__header--7EWb9","label":"Main__label--Tgbvu","breadcrumb":"Main__breadcrumb--4r6lb"};